// src/common/components/cartModal/components/checkout-stage/components/giftSelector/GiftSelector.tsx
import React from "react";
import { useSelector } from "react-redux";
import styles from "./GiftSelector.module.scss";
import { useTheme } from "../../../../hooks/useTheme";
import { getImageUri } from "../../../../utils/functions/getImageUri";
import { SaleItemInterface } from "../../../../types/types";
import { selectSaleItemList } from "../../../../../store/slices/saleItemListSlice";

interface GiftSelectorProps {
  giftItemIds: number[];
  selectedGiftId?: number;
  onSelect: (itemId: number) => void;
}

export default function GiftSelector({
  giftItemIds,
  selectedGiftId,
  onSelect,
}: GiftSelectorProps) {
  const { theme } = useTheme();

  // Берем товары из общего стора saleItemList
  const saleItemList = useSelector(selectSaleItemList);

  const giftItems = saleItemList.filter((item: SaleItemInterface) =>
    giftItemIds.includes(item.id),
  );

  if (giftItems.length === 0) {
    return null;
  }

  const isSelected = selectedGiftId !== undefined && selectedGiftId !== null;

  return (
    <div className={styles.container}>
      <div
        className={`${styles.header} ${!isSelected ? styles.required : ""}`}
        style={{
          borderColor: !isSelected ? theme.danger : theme.border,
          backgroundColor: theme.card,
        }}
      >
        <span className={styles.headerText} style={{ color: theme.text }}>
          {isSelected
            ? "✅ Подарок выбран"
            : "⚠️ Выберите подарок (обязательно)"}
        </span>
      </div>

      <div className={styles.grid}>
        {giftItems.map((item: SaleItemInterface) => {
          const isActive = selectedGiftId === item.id;

          return (
            <div
              key={item.id}
              className={`${styles.card} ${isActive ? styles.active : ""}`}
              style={{
                borderColor: isActive ? theme.primary : theme.border,
                backgroundColor: isActive ? `${theme.primary}15` : theme.card,
              }}
              onClick={() => onSelect(item.id)}
            >
              <img
                className={styles.image}
                src={`${getImageUri()}${item.files?.[0] || ""}`}
                alt={item.name}
              />
              <span className={styles.name} style={{ color: theme.text }}>
                {item.name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
